import {
    addToShortlist,
    removeFromShortlist,
    existsInShortlist,
} from "@/components/shortlist";

function updateButtonUI(button) {
    const text = button.querySelector('.exists')
    const data = { id: parseInt(button.dataset.buttonid) };
    const exists = existsInShortlist(data);

    if(exists) {
        text.innerText = 'Remove from'
    } else {
        text.innerText = 'Add to'
    }
}

function decorate(button) {
    updateButtonUI(button)

    const data = { id: parseInt(button.dataset.buttonid) };

    let exists = existsInShortlist(data);

    button.addEventListener("click", (e) => {
        e.preventDefault();

        if (!exists) {
            addToShortlist(data);
        } else {
            removeFromShortlist(data);
        }

        exists = existsInShortlist(data)
        updateButtonUI(button)
    });
}

export function init() {
    const buttons = Array.from(document.querySelectorAll("[data-buttonId]"));

    if (buttons.length) {
        buttons.forEach(decorate);
    }
}
